export default __webpack_public_path__ + "static/media/RecommendImageLarge.ec218b0a.png";